module.exports = require("./es-CR");